import { extractTextStructuredTextObject } from '~/App/components/DatoCMS/StructuredText/utils';
import { FaqQuestion } from '../cmsDataHandler';

const structureQuestion = (question: FaqQuestion) => {
  return {
    '@type': 'Question',
    name: question?.question ?? '',
    acceptedAnswer: {
      '@type': 'Answer',
      text: extractTextStructuredTextObject(question?.answer?.value) ?? ''
    }
  };
};

const structureSchema = (questions: FaqQuestion[]) => {
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions?.map(structureQuestion)
  };

  return JSON.stringify(schema);
};

export const getSchemaFromFaq = (
  questions: FaqQuestion[]
): { type: string; text: string } => {
  return { type: 'application/ld+json', text: structureSchema(questions) };
};
